import React from 'react'
import { Line } from 'react-chartjs-2'

import { values } from 'object.values'

if (!Object.values) {
  values.shim()
}

export default class RSRLLine extends React.Component {
  render() {
    // const feuil1 = this.props.data.allLettersXlsxFeuil1.edges
    // let labels = feuil1.map((row,i) => (row.node.letter))
    // let values = feuil1.map((row,i) => (row.node.value))
    let data = {
      labels: this.props.labels,
      datasets: [
        {
          label: this.props.label,
          borderWidth: 1,
          data: this.props.values,
          fill: false,
          borderWidth: 4,
          borderColor: '#d3adc7',
          pointBorderWidth: 0,
          pointRadius: 6,
          pointHoverRadius: 10,
          pointBackgroundColor: '#9b005b',
          barPercentage: 1,
        },
      ],
    }
    let options = {
      elements: {
        line: {
          tension: 0, // disables bezier curves
        },
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            scaleLabel: {
              display: this.props.xlabel != null,
              labelString: this.props.xlabel,
            },
            stacked: true,
            gridLines: { display: false },
          },
        ],
        yAxes: [
          {
            scaleLabel: {
              display: this.props.ylabel != null,
              labelString: this.props.ylabel,
            },
            stacked: true,
            gridLines: {
              display: true,
              color: '#DADADA',
              lineWidth: 1,
              tickMarkLength: 5,
              borderDash: [2, 2],
            },
            ticks: { display: true },
          },
        ],
      },
      tooltips: {
        mode: 'index',
        axis: 'x',
        cornerRadius: 0,
        xPadding: 16,
        yPadding: 16,
        backgroundColor: '#707070',
        caretPadding: 10,
      },
    }

    return (
      <div className="graph-wrapper">
        <div className="scroll-area">
          <Line data={data} options={options} />
        </div>
      </div>
    )
  }
}
